import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UsuarioService } from '../../services/usuario.service';
import { NgxSpinnerService } from "ngx-spinner";
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-nova-cidade',
  templateUrl: './nova-cidade.component.html',
  styleUrls: ['./nova-cidade.component.scss', '../../styles/estilo.padrao.scss']
})
export class NovaCidadeComponent implements OnInit {
  uid;
  cepForm: FormGroup;
  bCidade: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private toastr: ToastrService,
    private usuarioService: UsuarioService,
    private spinner: NgxSpinnerService,
  ) {
    this.uid = localStorage.getItem('uid')
  }

  maskCEP = [/\d/, /\d/, ".", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/];

  ngOnInit(): void {
    this.cepForm = this.formBuilder.group({
      cep: ['', [Validators.required]],
      cidade: ['', [Validators.required]],
      uf: ['', [Validators.required]],
      latitude: ['', [Validators.required]],
      longitude: ['', [Validators.required]],
    });
  }

  async buscarCEP() {
    if (this.f.cep.value.length == 10) {
      this.spinner.show('default');
      const resp: any = await this.usuarioService.getBuscaCEP(this.f.cep.value);
      const dados = resp;
      if (dados.erro) {
        this.toastr.warning("Cep inválido!", 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
        this.cepForm.get('cidade').patchValue('');
        this.cepForm.get('uf').patchValue('');
        this.bCidade = false;
      } else {
        this.cepForm.get('cidade').patchValue(dados.localidade);
        this.cepForm.get('uf').patchValue(dados.uf);

        this.cepForm.get('cidade').disable();
        this.cepForm.get('uf').disable();
        this.cepForm.get('latitude').disable();
        this.cepForm.get('longitude').disable();


        try {
          const aux: any = await this.usuarioService.getLatLng(this.f.cidade.value + '/' + this.f.uf.value);

          const dadosLatLng = aux.results[0].geometry.location;
          this.cepForm.get('latitude').patchValue(dadosLatLng.lat);
          this.cepForm.get('longitude').patchValue(dadosLatLng.lng);
          this.bCidade = true;
        }
        catch (err) {
          this.toastr.error('Não foi possível localizar a latitude e longitude da cidade informada.', 'Error', { progressBar: true, positionClass: 'toast-top-center', });
          this.limparCampos();
        };
      }

      setTimeout(() => this.spinner.hide('default'), 100);
    } else {
      this.cepForm.get('cidade').patchValue('');
      this.cepForm.get('uf').patchValue('');
      this.bCidade = false;
    }

  }

  cadastrar() {

    this.spinner.show('default');
    if (this.cepForm.valid) {
      this.usuarioService.getCidadeDuplicada(this.uid, this.f.uf.value.trim(), this.f.cidade.value.trim()).pipe(take(1)).subscribe(async snap => {
        if (snap.length === 0) {
          try {
            const resp = await this.usuarioService.setCidade(this.uid, this.f.uf.value.trim(), this.f.cidade.value.trim(), this.f.latitude.value, this.f.longitude.value);
            setTimeout(() => {
              this.spinner.hide('default');
              if (resp) {
                this.usuarioService.setLog("Cadastro de nova cidade: " + this.f.cidade.value.trim() + ' UF: ' + this.f.uf.value.trim(), false, this.uid);
              }
              this.limparCampos();
            }, 1500);
          } catch (e) {
            console.log(e)
            this.spinner.hide('default');

            this.usuarioService.setLog("Erro no cadastro de novo grupo: " + this.f.nomeGrupo.value.trim() + ' Erro: ' + e, null, this.uid);

            this.toastr.error('Erro ao cadastrar grupo!', 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
            this.limparCampos();
          }
        } else {
          this.toastr.error('Já existe uma cidade cadastrada com este nome!', 'Error', { progressBar: true, positionClass: 'toast-top-center', });
          setTimeout(() => this.spinner.hide('default'), 500);
        }
      });

    } else {
      this.toastr.error('Preencha todos os campos corretamente!', 'Error', { progressBar: true, positionClass: 'toast-top-center', });
      this.cepForm.markAllAsTouched();
      setTimeout(() => this.spinner.hide('default'), 500);
    }

  }

  limparCampos() {
    this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
      this.router.navigate(["/pages/nova-cidade"]));
  }

  // convenience getter for easy access to form fields
  get f() { return this.cepForm.controls; }

}
